import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from './authentication.service';

export const authGuard = async (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  const returnUrl =
    state?.url ??
    (route?.url?.length ? `/${route.url.map(s => s.path).join('/')}` : '/');

  await auth.waitForInitialization();

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl },
    });
  }

  const expectedRole =
    route?.data?.['expectedRole'] as string | undefined;

  if (expectedRole && !auth.hasRole(expectedRole)) {
    return router.createUrlTree(['/']);
  }

  const requiresAgency = route?.data?.['requiresAgency'] === true;

  if (requiresAgency && !auth.hasAgency()) {
    return router.createUrlTree(['/agency-wizard']);
  }

  return true;
};
